/**
 * Martin Saddlery — Judge.me review "Source"
 * -------------------------------------------------------------------------
 * Equibrand imports reviews from retail partners with a Judge.me custom
 * question "Source" (e.g. Teskey's). Judge.me's v3 widget lists that answer
 * under the review body; show it after the review date instead:
 * "10/07/2026 · Source: Teskey's". Reviews without a source are untouched.
 *
 * Runs again whenever Judge.me re-renders the list (paging, sorting,
 * filtering). Loaded from sections/main-product.liquid.
 */
(() => {
  const LABEL = 'source';
  const DONE = 'data-martin-source';

  const text = (el) => (el ? el.textContent.trim() : '');

  const moveSource = (item) => {
    if (item.hasAttribute(DONE)) return;

    const answer = [...item.querySelectorAll('.jm-text-answer')].find(
      (el) => text(el.children[0]).toLowerCase() === LABEL
    );
    if (!answer) return;

    const value = text(answer.children[1]);
    const dateRow = item.querySelector('.jm-reviewer-info__details')?.children[1];
    if (!value || !dateRow) return;

    item.setAttribute(DONE, '');

    // Nested in the date's own text element so it inherits the date styling.
    const date = dateRow.querySelector('.jm-text') || dateRow;
    const source = document.createElement('span');
    source.className = 'martin-review-source';
    source.textContent = ` · ${text(answer.children[0])}: ${value}`;
    date.appendChild(source);

    // Hide the answer below the body; hide the whole custom-answer list when
    // Source was its only entry so no empty gap is left behind.
    const list = answer.closest('.jm-custom-answer-list');
    const answers = list?.querySelector('.jm-custom-answer-list__content');
    if (list && answers && answers.children.length <= 1) {
      list.style.display = 'none';
    } else {
      (answer.parentElement === answers ? answer : answer.parentElement).style.display = 'none';
    }
  };

  let queued = false;
  const run = () => {
    queued = false;
    document.querySelectorAll('.jdgm-widget .jm-review-item').forEach(moveSource);
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  };

  const start = () => {
    schedule();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
